"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.themeKeys = void 0;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var themeKeys = {
  /** Which palette to use (light/dark) */
  mode: 'mode'
};
exports.themeKeys = themeKeys;

var theme = _defineProperty({}, themeKeys.mode, 'light');

var _default = theme;
exports.default = _default;